var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeather(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 156,
    viewBox: "0 0 114 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_1821_15766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.96 15.9464C85.96 15.9464 94.4234 29.4876 84.0286 40.8075C83.4329 37.0335 82.2448 33.3773 80.5082 29.9741C81.4256 34.3402 81.7226 38.8139 81.3905 43.263C78.6359 45.2544 75.5265 46.7017 72.2291 47.5273C72.6629 45.091 72.6178 42.5936 72.0965 40.1745C72.4133 42.824 71.9577 45.5085 70.7845 47.9051C64.5085 49.2478 58.0299 49.3437 51.7169 48.1873C51.7169 48.1873 55.0751 43.4816 59.2497 37.3648L63.2013 36.3602L60.3297 35.7818C62.6135 32.4601 65.0296 28.684 67.3135 25.3622L69.9924 24.9991L68.2424 24.1932C70.8062 20.5263 74.3706 17.6741 78.5104 15.9767L79.8755 17.0108L79.0135 15.7916C80.6499 15.1686 82.3627 14.7677 84.1057 14.5999C87.1291 11.6744 89.5015 8.14405 91.0679 4.2394L90.974 4.03759C92.9409 8.47427 85.96 15.9464 85.96 15.9464Z",
    fill: "url(#paint0_linear_1821_15766)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.2048 4.32221C90.2421 8.59503 87.9764 12.4635 84.7205 15.3932C80.3242 18.741 76.4533 22.7275 73.2361 27.2203C69.1771 33.4798 62.8402 44.9731 51.9532 48.2729C51.9532 48.2729 55.3115 43.5673 59.486 37.4504L63.4378 36.4458L60.5661 35.8674C62.85 32.5457 65.2659 28.7696 67.5498 25.4478L70.2288 25.0847L68.4789 24.2788C71.0427 20.6119 74.607 17.7597 78.7469 16.0623L80.112 17.0964L79.2499 15.8772C80.8864 15.2542 82.599 14.8534 84.342 14.6856C87.3299 11.7497 89.668 8.21903 91.2048 4.32221Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0723 87.9247C31.0723 87.9247 17.953 114.237 39.0038 133.148C39.4289 126.126 40.9605 119.215 43.542 112.671C42.632 120.835 42.878 129.087 44.2725 137.182C49.6729 140.345 55.6273 142.448 61.8164 143.379C60.5911 138.99 60.2325 134.405 60.7605 129.88C60.648 134.792 61.9572 139.631 64.5307 143.816C76.2703 145.168 88.1609 144.2 99.5268 140.965C99.5268 140.965 92.5407 132.934 83.8092 122.461L76.3894 121.318L81.5503 119.75C76.7777 114.066 71.6825 107.572 66.91 101.888L61.9361 101.695L65.001 99.9092C59.6544 93.6416 52.6181 89.0439 44.7309 86.6643L42.4116 88.8006L43.7762 86.4139C40.6669 85.5611 37.4571 85.129 34.2329 85.1293C28.1749 80.3017 23.2033 74.2505 19.6427 67.371L19.7792 66.9845C16.9581 75.4633 31.0723 87.9247 31.0723 87.9247Z",
    fill: "url(#paint1_linear_1821_15766)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4059 67.5469C21.925 75.2079 26.7609 81.8975 33.2455 86.6918C41.8944 92.0509 49.693 98.6733 56.3829 106.339C64.9279 117.094 78.572 137.039 99.1082 141.164C99.1082 141.164 92.122 133.133 83.3906 122.66L75.9706 121.516L81.1314 119.949C76.3588 114.265 71.2639 107.771 66.4914 102.086L61.5172 101.894L64.5821 100.108C59.2355 93.8402 52.1992 89.2425 44.312 86.8629L41.9927 88.9992L43.3573 86.6126C40.248 85.7597 37.0384 85.3277 33.8143 85.328C27.8195 80.4752 22.9108 74.4173 19.4059 67.5469Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1821_15766",
    x: 47.7169,
    y: 0.0375977,
    width: 47.6064,
    height: 52.9512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1821_15766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1821_15766",
    x1: 90.974,
    y1: 4.03759,
    x2: 85.607,
    y2: 58.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF84D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1821_15766",
    x1: 19.7792,
    y1: 66.9845,
    x2: 39.3057,
    y2: 166.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF84D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6E6E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather);
export default __webpack_public_path__ + "static/media/Feather.3fc741498e73db0de8e790320bc8c121.svg";
export { ForwardRef as ReactComponent };